/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { FuelSurchargeSource } from "./FuelSurchargeSource";
import {
  FuelSurchargeSourceFromJSON,
  FuelSurchargeSourceFromJSONTyped,
  FuelSurchargeSourceToJSON,
  FuelSurchargeSourceToJSONTyped,
} from "./FuelSurchargeSource";

/**
 *
 * @export
 * @interface FuelSurchargeValueDTO
 */
export interface FuelSurchargeValueDTO {
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueDTO
   */
  fuelSurchargeValueId: string;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueDTO
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueDTO
   */
  fuelSurchargeIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof FuelSurchargeValueDTO
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValueDTO
   */
  notes?: string | null;
  /**
   *
   * @type {FuelSurchargeSource}
   * @memberof FuelSurchargeValueDTO
   */
  source: FuelSurchargeSource;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FuelSurchargeValueDTO
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FuelSurchargeValueDTO
   */
  lastUpdatedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the FuelSurchargeValueDTO interface.
 */
export function instanceOfFuelSurchargeValueDTO(
  value: object,
): value is FuelSurchargeValueDTO {
  if (
    !("fuelSurchargeValueId" in value) ||
    value["fuelSurchargeValueId"] === undefined
  )
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("fuelSurchargeIdentifier" in value) ||
    value["fuelSurchargeIdentifier"] === undefined
  )
    return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("source" in value) || value["source"] === undefined) return false;
  return true;
}

export function FuelSurchargeValueDTOFromJSON(
  json: any,
): FuelSurchargeValueDTO {
  return FuelSurchargeValueDTOFromJSONTyped(json, false);
}

export function FuelSurchargeValueDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FuelSurchargeValueDTO {
  if (json == null) {
    return json;
  }
  return {
    fuelSurchargeValueId: json["fuelSurchargeValueId"],
    carrierIdentifier: json["carrierIdentifier"],
    fuelSurchargeIdentifier: json["fuelSurchargeIdentifier"],
    value: json["value"],
    notes: json["notes"] == null ? undefined : json["notes"],
    source: FuelSurchargeSourceFromJSON(json["source"]),
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    lastUpdatedAt:
      json["lastUpdatedAt"] == null ? undefined : json["lastUpdatedAt"],
  };
}

export function FuelSurchargeValueDTOToJSON(json: any): FuelSurchargeValueDTO {
  return FuelSurchargeValueDTOToJSONTyped(json, false);
}

export function FuelSurchargeValueDTOToJSONTyped(
  value?: FuelSurchargeValueDTO | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fuelSurchargeValueId: value["fuelSurchargeValueId"],
    carrierIdentifier: value["carrierIdentifier"],
    fuelSurchargeIdentifier: value["fuelSurchargeIdentifier"],
    value: value["value"],
    notes: value["notes"],
    source: FuelSurchargeSourceToJSON(value["source"]),
    createdAt: value["createdAt"],
    lastUpdatedAt: value["lastUpdatedAt"],
  };
}
